<template>
  <div>
    <b-navbar
      toggleable="lg"
      type="dark"
      class="navbar navbar-light navbar-abs fixed-top"
      :style="opacityStyle"
    >
      <div class="container">
        <b-navbar-brand to="/">
          <img
            class=""
            src="@/assets/images/home-logo.png"
            alt="益狐智造科技（武汉）有限公司"
          />
        </b-navbar-brand>

        <!-- 折叠  用于自适应 -->
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <!-- b-collapse 需要折叠的内容 -->
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item to="/">{{
              $tc("message.home_nav.nav_title_home")
            }}</b-nav-item>
            <b-nav-item to="/company">{{
              $tc("message.home_nav.nav_title_one")
            }}</b-nav-item>
            <b-nav-item to="/module">{{
              $tc("message.home_nav.nav_title_two")
            }}</b-nav-item>
            <b-nav-item to="/case">{{
              $tc("message.home_nav.nav_title_three")
            }}</b-nav-item>
            <b-nav-item to="/solution">{{
              $tc("message.home_nav.nav_title_four")
            }}</b-nav-item>
            <b-nav-item to="/video">{{
              $tc("message.home_nav.nav_title_five")
            }}</b-nav-item>
            <b-nav-item to="/contact">{{
              $tc("message.home_nav.nav_title_six")
            }}</b-nav-item>
            <b-nav-item to="/download">{{
              $tc("message.home_nav.nav_title_seven")
            }}</b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown class="nav-link" :text="language" right>
              <b-dropdown-item @click="languageCH">简体中文</b-dropdown-item>
              <!-- <b-dropdown-item @click="languageUS">English</b-dropdown-item> -->
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "HomeHeaderNavBar",
  data() {
    return {
      language: this.$tc("message.language"),
      opacityStyle: {
        opacity: 0.7
      }
    };
  },
  methods: {
    handleScroll() {
      const top = document.documentElement.scrollTop;
      if (top > 180) {
        let opacity = top / 300;
        opacity = opacity > 1 ? 1 : opacity;
        this.opacityStyle = {
          opacity: opacity
        };
      } else {
        let opacity = 0.7;
        this.opacityStyle = {
          opacity: opacity
        };
      }
    },
    languageCH() {
      this.$i18n.locale = "zh-CN";
      this.language = this.$tc("message.language");
    },
    languageUS() {
      this.$i18n.locale = "en-US";
      this.language = this.$tc("message.language");
    }
  },
  activated() {
    window.addEventListener("scroll", this.handleScroll);
  },
  deactivated() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="stylus" scoped>
.navbar-abs {
  margin-right: 0;
  background: rgba(0, 0, 0, 1);

  .nav-link {
    color: #fff;
    font-weight: bolder;
    width: 100px;
    text-align: center;
  }

  .nav-link.router-link-exact-active {
    padding-bottom: 5px;
    color: gray;
    border-bottom: gray 1px solid;
  }

  .nav-link:hover {
    color: gray;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/HeaderNavBar.vue